import { ref, onMounted, onUnmounted } from 'vue';

export function useIsMobile() {
  const isMobile = ref(window.innerWidth <= 700);

  const updateIsMobile = () => {
    isMobile.value = window.innerWidth <= 700;
  };

  onMounted(() => {
    window.addEventListener('resize', updateIsMobile);
    updateIsMobile(); // Set the initial state on mount
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateIsMobile);
  });

  return { isMobile };
}
